<template>
    <button
        v-tippy="t('editorToggleOrderedList')"
        :class="[
            buttonState(editor.can().toggleOrderedList(), editor.isActive('orderedList')),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="!editor.can().toggleOrderedList()"
        @click="editor.chain().focus().toggleOrderedList().run()"
    >
        <MdiFormatListNumbered class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiFormatListNumbered from 'materialdesignicons-vue3/icons/MdiFormatListNumbered.js';

    defineExpose({
        name: 'OrderedListButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
